import { _, React, classNames, withStyles, StyledProps, CentricTheme } from '@api'
import {AppBar as MaterialTitleBar, Toolbar } from '@material-ui/core'

const styles = (theme: CentricTheme) => ({
  header: {
    boxShadow: 'none',
    borderBottom: '1px solid #e1e1e1'
  },
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between'
  }
})

interface MyProps extends StyledProps {
  /** Sticky poistion from top in pixel */
  top: number
}

export class TitleBarComponent extends React.Component<MyProps> {
  static defaultProps = {
    top: 64
    }

  render() {
    const {classes, className, children, top} = this.props
    return (
      <MaterialTitleBar position={'sticky'} color={'secondary'} elevation={3} style={{top: `${top}px`}} className={classNames(className, classes.header)}>
        <Toolbar className={classes.undo}>
          {children}
        </Toolbar>
      </MaterialTitleBar>
    )
  }
}

@(withStyles as any)(styles)
export class TitleBar extends TitleBarComponent{}



// WEBPACK FOOTER //
// ./src/shared/components/ui/components/TitleBar.tsx